import {useErrorHandling} from '@/composables/use-error-handling.js'
import {ref} from 'vue'

/**
 * Search composable
 */
export function useSearch(fullSearchHandler, partialSearchHandler) {

  //Composables
  const {processError} = useErrorHandling()

  //Refs
  const searchTerm = ref('')
  const partialSearchResults = ref([])
  const isDoingFullSearch = ref(false)

  //Perform a partial search
  const partialSearch = async search => {

    //Not when still doing a full search
    if (isDoingFullSearch.value) {
      return
    }

    //No partial search handler
    if (!partialSearchHandler) {
      return
    }

    //Perform partial search
    try {
      const results = await partialSearchHandler(search)

      //Only update the search results if we not doing a full search
      if (!isDoingFullSearch.value) {
        partialSearchResults.value = results
      }
    }
    catch (error) {
      processError(error)
      throw error
    }
  }

  //Perform a full search
  const fullSearch = async search => {

    //Indicate we're doing a full search and update search term
    isDoingFullSearch.value = true
    partialSearchResults.value = []
    searchTerm.value = search

    //Call handler
    try {
      await fullSearchHandler(search)
    }
    catch (error) {
      processError(error)
      throw error
    }
    finally {

      //Clear the flag after a short delay to ensure partial search results that
      //return later don't interfere with the full search
      setTimeout(() => {
        isDoingFullSearch.value = false
      }, 500)
    }
  }

  //Clear the search
  const clearSearch = () => fullSearch('')

  //Expose interface
  return {
    searchTerm,
    partialSearchResults,
    isDoingFullSearch,
    partialSearch,
    fullSearch,
    clearSearch,
  }
}
